import React, {Component} from 'react';
import {client} from '../../Client';
import MovimentoDetail from './MovimentoDetail'
import ErrorMessage from '../ErrorMessage'
import {convertNullToEmptyString} from '../../Helpers'
import PropTypes from 'prop-types';
class MovimentiView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.match.params.id,
            fields: {},
            _loading: false

        };
        this.loadMovimento = this.loadMovimento.bind(this)
        this.onDeleteMovimento = this.onDeleteMovimento.bind(this)
    }

    componentWillMount() {
        this.loadMovimento();
    }

    loadMovimento(){
        this.setState({ _loading: true });
        client.loadMovimento(this.state.id).then(
            (response) => {
                if (response.ok){
                    response.json().then((movimento) => {
                        let fields = convertNullToEmptyString(movimento);
                        this.setState({ _loading: false, fields: fields,  fieldErrors: {}, error: null});
                        this.forceUpdate();
                    })
                }
                else if (response.status === 401)
                {
                    this.props.history.push("/login")
                }
                else
                {
                    response.json().then((errore) => {
                        this.setState({
                            _loading: false,
                            error: {title: errore.title, msg: errore.msg},
                        });
                    });

                }
            }).catch((error) => {

            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    onDeleteMovimento(ev, movimento){
        this.setState({_loading: true});
        client.deleteMovimento(movimento).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null
                });
                this.props.history.push("/app/movimenti")
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });

    }


    render() {
        if (this.state.error != null){
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }
        else {
            return (<MovimentoDetail
                movimento={this.state.fields}
                loading={this.state._loading}
                onClickDelete={this.onDeleteMovimento}
                readOnly={client.getCurrentUser().isrolemovimentiw === false}
            />)
        }
    }
}

MovimentiView.contextTypes = {
    router: PropTypes.object
}

export default MovimentiView;




/** WEBPACK FOOTER **
 ** ./src/components/movimenti/MovimentiView.js
 **/